var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-toolbar',{staticClass:"scroll",attrs:{"dense":"","flat":"","color":"grey lighten-3"}},_vm._l((_vm.links),function(link,i){return _c('v-btn',{key:i,attrs:{"text":"","exact":"","to":link.path}},[_vm._v(_vm._s(link.name))])}),1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }